import {
  TargetSystemActiveAgent,
  TargetSystemGoogleDdp,
  TargetSystemId,
  TargetSystemTTD, TargetSystemTTDDataAlliance,
  TargetSystemXandr,
  TargetSystemXandrCrtt
} from '../distribution-account/distribution-account.model';
import {AdditionalSharingConfig} from './segment-share.service';
import {TtdDataRate} from '../ttd/ttd-data-rate/ttd-data-rate.types';


export type AccountConfigurationWrapper = {
  accountId: number;
  config: AdditionalSharingConfig;
};

export type AccountConfigurationSystemId =
  TargetSystemGoogleDdp
  | TargetSystemActiveAgent
  | TargetSystemTTD
  | TargetSystemTTDDataAlliance
  | TargetSystemXandr
  | TargetSystemXandrCrtt;

export const isMultiShareConfigSupported = (systemId: number) => {
  return [TargetSystemId.GOOGLE_DDP,
    TargetSystemId.ACTIVE_AGENT,
    TargetSystemId.XANDR,
    TargetSystemId.XANDR_CRTT,
    TargetSystemId.TTD,
    TargetSystemId.TTD_DATA_ALLIANCE,
    TargetSystemId.PUBMATIC,
    TargetSystemId.PUBMATIC_CRTT]
    .includes(systemId);
};


export interface ShareRequest {
  segmentId: number;
  accounts: ShareAccount[];
}

export interface ShareMessage {
  message: string;
  type: ShareMessageType;
}

export enum ShareMessageType {SUCCESS = 'SUCCESS', ERROR = 'ERROR', WARN = 'WARN'}

export interface TheTradeDeskPriceShare {
  accountId: number;
  segmentId: number;
  rate: TtdDataRate;
  buyerId: string;
  groupId?: number;
  brandId?: string;
}

export interface Share {
  id: string;
  accountIds: number[];
  segmentIds: number[];
  shareResults: ShareResult[];
  state: 'IN_PROGRESS' | 'FINISHED'
}

export interface ShareResult {
  segmentId?: number;
  foreignSegmentId?: string;
  accountName?: string;
  accountId: number;
  shareMessages: ShareMessage[]
}

export interface ShareAccount {
  distributionId: number;
  foreignId?: string;
  additionalSharingConfiguration?: AdditionalSharingConfig;
}
